import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'

const StudioPage = lazy(() => import('@/sanity/studio'))

export const Route = createFileRoute('/studio/$')({
  ssr: false,
  component: () => (
    <Suspense fallback={null}>
      <StudioPage />
    </Suspense>
  ),
})
